import { trimNumericInput } from 'src/app/core/helpers/trim-numeric-input';

export const parseNumericValue = (value: string | null | undefined): number | null => {
  if (!value) {
    return null;
  }
  const parsed = Number(trimNumericInput(value));
  return Number.isFinite(parsed) ? parsed : null;
};
